import { Flex } from "@ui/components/layout/flex/Flex";
import { Text } from "@ui/components/content/text/Text";
import { memo } from "react";
import type { ImageWithVideo } from "@pages/product/[productName]/[articleNumber]/[colorCode]";
import { IconButton } from "@ui/components/forms/icon-button/IconButton";
import { Box } from "@ui/components/layout/box/Box";
import { ECCOIcon } from "@ui/components/media-and-icons/ecco-icon/ECCOIcon";
import ReactPlayer from "react-player";
import VideoStyles from "@components/cms/video/video.module.css";

type ProductImageThumbnailProps = {
    index: number;
    currentlySelected: boolean;
    image: ImageWithVideo;
    setImageIndex: (index: number) => void;
    alt: string;
};

export const ProductVideoThumbnail = memo(
    ({ index, currentlySelected, image, setImageIndex }: ProductImageThumbnailProps) => {
        const beforePseudoElementStyles = {
            content: "''",
            position: "absolute",
            left: "0",
            bottom: "0",
            width: "100%",
            height: "1.7px",
            backgroundImage: " linear-gradient(#000,#000)",
            transition: "transform .2s ease-in-out",
            willChange: "transform",
            transformOrigin: "left bottom",
        };

        const isInteractiveVideo = !!image.video720;

        return (
            <Flex
                key={image.url}
                mt="0.5"
                aspectRatio={"2 / 3"}
                position={"relative"}
                order={image.video720 ? 10 : 1}
                onClick={() => {
                    setImageIndex(index);
                }}
                sx={{
                    " &::before": {
                        ...beforePseudoElementStyles,
                        transform: currentlySelected ? "scaleX(1)" : "scaleX(0)",
                    },
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                }}
            >
                {isInteractiveVideo ? (
                    <Text>720°</Text>
                ) : (
                    <>
                        <IconButton
                            aria-label="Play video"
                            icon={<ECCOIcon name={"play"} />}
                            w="100%"
                            h="100%"
                            colorScheme="transparent"
                            position={"absolute"}
                            zIndex={2}
                            bg="rgba(0, 0, 0, 0.35)"
                        />
                        <ReactPlayer
                            // Add or ask for Skeleton design
                            fallback={<Box />}
                            className={VideoStyles["react-player"]}
                            url={image.url}
                            height="100%"
                            width="100%"
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "hidden",
                            }}
                            controls={false}
                            playing={false}
                            muted={true}
                            volume={0}
                            loop={true}
                        />
                    </>
                )}
            </Flex>
        );
    }
);

ProductVideoThumbnail.displayName = "ProductVideoThumbnail";
